import { useNavigate } from 'react-router';
import { ArrowUpIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import ALinkableCard from 'components/atoms/ALinkableCard';
import { useTranslation } from 'helpers/languages/translations';
import PageHeader from 'layout/pageHeader';

import ImagesViewer from './components/organisms/ImagesViewer/ImagesViewer';
import { KPIS } from './contants';
import { entries } from 'utils/wrappers';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { FC } from 'react';

const PATH = 'pictures-management';
const ID = 'cdm_picturesmanager';
const NAME = 'page.pictures';

const RenderTabs: FC<{ readonly: boolean }> = ({ readonly }) => (
    <Tabs variant="DITabs" size="sm">
        {/* <TabList>
            <Tab>LIBRARY</Tab>
            <Tab>REVIEW</Tab>
            <Tab>UPLOAD</Tab>
        </TabList> */}
        <TabPanels>
            <TabPanel px="0">
                <ImagesViewer readonly={readonly} />
            </TabPanel>
            <TabPanel px="0"></TabPanel>
            <TabPanel px="0"></TabPanel>
        </TabPanels>
    </Tabs>
);

const RenderKpis = () => (
    <Flex mb={2}>
        {entries(KPIS).map(([kpiKey, kpi]) => (
            <ALinkableCard key={kpiKey} title={kpi.title} value={'test'} mr={6} mb={6} />
        ))}
    </Flex>
);

const ImageManagment = () => {
    const navigate = useNavigate();
    const translate = useTranslation();
    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(19);

    return (
        <Box>
            <PageHeader icon={{ name: 'image' }} pageTitle={translate(NAME) as string} readonly={readonly}>
                <Button
                    onClick={() => {
                        navigate(`./upload/`);
                    }}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                    isDisabled={readonly}
                >
                    {translate('pictures.upload')}
                </Button>
            </PageHeader>
            <Box px="32px">
                <RenderTabs readonly={readonly} />
            </Box>
        </Box>
    );
};

export { PATH, ID, NAME };
export default ImageManagment;
